import {Movie} from './Movie';
import {Serie} from './Serie';

const configureServices:any = () => {
  return {
    movie: new Movie(),
    serie: new Serie(),
  };
};

export default configureServices;